import type { ApprovalSummaryResult } from "@/modules/hr/overtime/domain/types";
import { Card, CardContent } from "@devhop/ui";
import { Hourglass } from "lucide-react";

type OTApprovalSummaryCardsProps = {
  data: ApprovalSummaryResult | undefined;
  isLoading?: boolean;
};

function toPendingCount(value: unknown): number {
  if (typeof value === "number" && Number.isFinite(value)) return Math.max(0, Math.floor(value));
  if (typeof value === "string") {
    const n = Number(value);
    if (Number.isFinite(n)) return Math.max(0, Math.floor(n));
    try {
      const parsed = JSON.parse(value) as { pendingCount?: unknown };
      return toPendingCount(parsed?.pendingCount);
    } catch {
      return 0;
    }
  }
  return 0;
}

export function OTApprovalSummaryCards({
  data,
  isLoading,
}: OTApprovalSummaryCardsProps) {
  const pendingCount = toPendingCount(data?.pendingCount);

  if (isLoading) {
    return (
      <div className="mb-6 grid gap-4 md:grid-cols-1">
        <div className="animate-pulse rounded-xl border bg-card p-6">
          <div className="h-4 w-32 rounded bg-muted" />
          <div className="mt-2 h-8 w-24 rounded bg-muted" />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 grid gap-4 md:grid-cols-1">
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <Hourglass className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              ກຳລັງດຳເນີນການອະນຸມັດ
            </p>
            <p className="font-semibold text-xl">{pendingCount} ຄຳຂໍ</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
